import React, { useState, useContext, useEffect } from "react";
import { StoreContext } from "../../../store";

import Button from "react-bootstrap/Button";
//import "../../../../src/styles.less";
import ModalWrapper from "../modal/Modal";
import { SendMessage } from "../../../actions";

const ContactUsModal = (props) => {
  
  const { dispatch } = useContext(StoreContext);

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Phone, setPhone] = useState("");
  const [MessageBody, setMessageBody] = useState("");
  const [Subject, setSubject] = useState("");


  let handleSend = () => {
    var Message = { Name: "", Email: "", Phone: "",Subject:"", MessageBody: "" };
    Message.Name = Name;
    Message.Email = Email;
    Message.Phone = Phone;
    Message.MessageBody = MessageBody;
    Message.Source = "wingandaprayerloft.com Contact Page";
    Message.Subject = Subject;

    SendMessage(dispatch, Message);
    props.closeModal();
  };
  return (
    <ModalWrapper
      title="We love to hear from you"
      show={props.show}
      closeModal={props.closeModal}
      handleOnClick={() => handleSend()}
    >
      <div className="contact-us-container">
        <div className="row">
          <div className="col-sm text-left">
            <span className="font-weight-bold">Email Us at</span>

            <span>
              {" "}
              <a href="mailto:rwhull@hotmail.com">rwhull@hotmail.com</a>
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-sm text-left  text-wrap">
            <span className="font-italic">
              You can also drop us a message in Facebook @ rwhull or use the
              form below.
            </span>
          </div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-sm">
            <form>
              <ul className="flex-outer">
                <li>
                  <label for="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Your Name"
                    value={Name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </li>
                <li>
                  <label for="name">Email</label>
                  <input
                    type="text"
                    id="email"
                    placeholder="Your Email"
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </li>
                <li>
                  <label for="phone">Phone</label>
                  <input
                    type="text"
                    id="phone"
                    placeholder="Your Phone"
                    value={Phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </li>
                <li>
                  <label for="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    placeholder="Subject"
                    value={Subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                  />
                </li>
                <li>
                  <label for="Message">Your Message</label>

                  <textarea
                    className="contact-ta"
                    id="message"
                    value={MessageBody}
                    onChange={(e) => setMessageBody(e.target.value)}
                  />
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
};
export default ContactUsModal;
